<template>
  <div class="account-book-overview">
    <div v-if="accountBook">
      <h2 class="title is-flex is-align-items-center is-justify-content-space-between">
        <router-link :to="`/${accountBook.slug}`" class="has-text-primary-dark has-text-weight-bold">{{ accountBook.name }}</router-link>

        <span>
          <router-link :to="`/${accountBook.slug}/invite`" class="button is-primary is-small is-rounded mr-1">
            <span class="icon is-small">
              <i class="fas fa-user-plus" aria-hidden="true"></i>
            </span>
          </router-link>
          <dropdown id="accountBookDropdown">
            <template slot="dropdownContent">
              <router-link :to="`/${accountBook.slug}/transactions`" class="dropdown-item">
                {{ $t('transactions.title') }}
              </router-link>
              <router-link :to="`/${accountBook.slug}/categories`" class="dropdown-item">
                {{ $t('categories.title') }}
              </router-link>
            </template>
          </dropdown>
        </span>
      </h2>

      <router-view />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import ClickOutside from 'vue-click-outside'
import Dropdown from '../basic/Dropdown'

export default {
  name: 'account-book',
  components: { Dropdown },
  computed: {
    ...mapState({
      accountBook: state => state.accountBooks.current
    })
  },
  data () {
    return {
      showDropdown: false
    }
  },
  created () {
    this.$store.dispatch('accountBooks/get', this.$route.params.accountBookSlug)
  },
  methods: {
    hideDropdown () {
      this.showDropdown = false
    }
  },
  directives: {
    ClickOutside
  }
}
</script>

<style scoped lang="scss">
  @import '../../assets/scss/variables';

  h2 {
    padding: 0.5rem 0;
    border-bottom: 0.1rem solid lighten($primary, 15);
  }
</style>
